// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__X4el4","newExpiryDate":"styles_newExpiryDate__XPLZl","footer":"styles_footer__26gje"};